const mediaItems = [
  {
    title: '《斗罗大陆》最新话',
    desc: '唐三突破封号斗罗，决战武魂殿！海量弹幕刷屏中',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20manga%20style%20illustration%20of%20a%20martial%20arts%20hero%20in%20dynamic%20battle%20pose%20with%20glowing%20energy%20effects%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20dramatic%20lighting%2C%20clean%20simple%20background%20with%20soft%20bokeh%2C%20anime%20style%20digital%20art%2C%20horizontal%20thumbnail%20format&width=600&height=340&seq=media-douluo&orientation=landscape',
  },
  {
    title: '《完美世界》动画联动',
    desc: '石昊独断万古名场面，漫画与动画同步热播',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20illustration%20featuring%20a%20young%20warrior%20with%20flowing%20hair%20standing%20on%20a%20mountain%20peak%2C%20celestial%20phenomenon%20in%20the%20sky%2C%20warm%20orange%20and%20peach%20sky%2C%20epic%20scale%2C%20Chinese%20xianxia%20aesthetic%2C%20clean%20minimal%20background%2C%20horizontal%20format&width=600&height=340&seq=media-wanmei&orientation=landscape',
  },
  {
    title: '《一人之下》特别篇',
    desc: '异人世界全新篇章开启，张楚岚身世之谜揭晓',
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20fantasy%20manga%20scene%20with%20supernatural%20elements%2C%20a%20character%20using%20mystical%20powers%20in%20a%20city%20alley%2C%20neon%20and%20warm%20lighting%2C%20stylish%20character%20design%2C%20Chinese%20contemporary%20manga%20style%2C%20horizontal%20thumbnail&width=600&height=340&seq=media-yiren&orientation=landscape',
  },
  {
    title: '《镖人》重磅回归',
    desc: '刀马再度踏上江湖路，硬核武侠画风震撼人心',
    img: 'https://readdy.ai/api/search-image?query=Gritty%20historical%20Chinese%20manga%20scene%20with%20a%20lone%20swordsman%20in%20traditional%20robes%20walking%20through%20a%20dusty%20desert%20landscape%2C%20dramatic%20shadows%2C%20ink%20wash%20painting%20style%20blended%20with%20modern%20manga%2C%20warm%20earthy%20tones%2C%20horizontal%20format&width=600&height=340&seq=media-biaoren&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">热门连载实时追踪，发现你最爱的漫画作品</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group relative bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center backdrop-blur-sm">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}